import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'AnalyticalKey';
const ENDPOINT = `/analytical-keys/`;

@Injectable({
    providedIn: 'root'
})
export class AnalyticalKeyService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
